import { apiClient } from './client';
import { CategoriaFinanceira, LancamentoFinanceiro, ResumoFinanceiro } from '../types';

export function listarCategoriasFinanceiro(): Promise<CategoriaFinanceira[]> {
  return apiClient.get('/financeiro/categorias').then((res) => res.data.categorias);
}

export function criarCategoriaFinanceiro(nome: string, tipo: string): Promise<CategoriaFinanceira> {
  return apiClient.post('/financeiro/categorias', { nome, tipo }).then((res) => res.data.categoria);
}

export function listarLancamentos(): Promise<{ lancamentos: LancamentoFinanceiro[]; resumo: ResumoFinanceiro }> {
  return apiClient.get('/financeiro/lancamentos').then((res) => res.data);
}

export interface DadosLancamento {
  categoria_id: number | string;
  valor: number | string;
  descricao?: string;
  data?: string;
}

export function criarLancamento(dados: DadosLancamento): Promise<LancamentoFinanceiro> {
  return apiClient.post('/financeiro/lancamentos', dados).then((res) => res.data.lancamento);
}

export function removerLancamento(id: number): Promise<{ ok: boolean }> {
  return apiClient.delete(`/financeiro/lancamentos/${id}`).then((res) => res.data);
}
